/**
 * Checks if the current pathname matches any pattern in showForPaths.
 * Each pattern can be:
 * - Exact match: pathname === pattern (e.g. "/app/assets/folders/0172a4f7-e140-ee4c-d1c8-c63a9e8c4756")
 * - Regex: pattern is used as regex (e.g. "^/app/assets/folders/[a-f0-9-]+$" for all folder UUIDs)
 */
export function pathMatchesShowForPaths(
  pathname: string,
  showForPaths: string[] | undefined,
): boolean {
  if (!showForPaths?.length) return false;

  for (const pattern of showForPaths) {
    const trimmed = pattern.trim();
    if (!trimmed) continue;

    // Try as regex first (patterns with regex meta chars)
    if (looksLikeRegex(trimmed)) {
      try {
        const regex = new RegExp(trimmed);
        if (regex.test(pathname)) return true;
      } catch {
        // Invalid regex, fall back to exact match
        if (pathname === trimmed) return true;
      }
    } else {
      // Exact match
      if (pathname === trimmed) return true;
    }
  }
  return false;
}

/** Heuristic: pattern looks like regex if it contains regex meta chars. Excludes . since it's common in paths (e.g. v1.0, readme.md). */
function looksLikeRegex(pattern: string): boolean {
  return /[*+?^${}()|[\]\\]/.test(pattern);
}
